const GO_STORAGE_KEY = '@GO_LOCAL_STORAGE';

export type GOLocalStorage = Partial<{
  lastPropertyId: string;
  currentSailingUrl: string;
  apiTokenKey: string;
  cellWidth: number;
  cellHeight: number;
  dailyScheduleWidth: number;
  staffConflictsWidth: number;
  feedZoom: number;
  feedScrollLeft: number;
  feedScrollTop: number;
  canvasEventFilters: string[];
  canvasVenueFilters: string[];
  simulateMargins: boolean;
  canvasSingleColMode: boolean;
  showArchivedGroups: boolean;
  permissionOverrides: Record<string, boolean>;
}>;

function isGOLocalStorage(arg: any): arg is GOLocalStorage {
  // TODO: how to do this properly ?
  return arg instanceof Object;
}

function generateDefaultLocalStorage(): GOLocalStorage {
  return {};
}

export function getStorage(): GOLocalStorage {
  try {
    const ls = JSON.parse(localStorage.getItem(GO_STORAGE_KEY) || '');
    if (!isGOLocalStorage(ls)) throw new Error('Not of expected type!');
    return ls;
  } catch {
    return generateDefaultLocalStorage();
  }
}

export function setStorage<T extends keyof GOLocalStorage>(key: T, value: GOLocalStorage[T]) {
  const oldLs = getStorage();
  const newLs = { ...oldLs, [key]: value };
  const ls = JSON.stringify(newLs);
  localStorage.setItem(GO_STORAGE_KEY, ls);
}

export function unsetStorage<T extends keyof GOLocalStorage>(key: T) {
  const oldLs = getStorage();
  const newLs = { ...oldLs };
  delete newLs[key];
  const ls = JSON.stringify(newLs);
  localStorage.setItem(GO_STORAGE_KEY, ls);
}
